import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddReligionFailure,
  AddReligionSuccess,
  EditReligionFailure,
  EditReligionSuccess,
} from '../../Redux/Actions/ReligionAction';
import { ADD_RELIGION, EDIT_RELIGION } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddReligionEpic = action$ =>
  action$.pipe(
    ofType(ADD_RELIGION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addReligion`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.religionmanagement, toast.success(response.response.message));
              return of(AddReligionSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(AddReligionFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditReligionEpic = action$ =>
  action$.pipe(
    ofType(EDIT_RELIGION),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editReligion`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditReligionSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditReligionFailure(response.response));
            }
          }),
        ),
    ),
  );
